import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.XeroExternalSubmitterSection', {
    bubbleText: 'Pulling from Xero',
    learnMore: 'Learn more',
    externalSubmitterRequiredValidationText: 'Please select a Requester',
    chooseRequester: 'Choose a Requester',
});
